import React, { forwardRef } from 'react';

import useTableCurrentState from 'hooks/useTableCurrentState';

import { ITableDataItem } from 'api/queries/relationActivity.query';

import { CustomTableColumnsModal } from 'components/common/Modals/CustomTableColumns/customTableColumnsModal';
import MainTable from 'components/common/Tables/MainTable/MainTable';

import {
    columns,
    initialState,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/relationships/tables/successorsTableWrapper.utils';

interface ISuccessorsTableWrapperProps {
    data: ITableDataItem[];
    modalColumnsOpen: boolean;
    setModalColumnsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SuccessorsTableWrapper = forwardRef(
    ({ data, modalColumnsOpen, setModalColumnsOpen }: ISuccessorsTableWrapperProps, ref: any) => {
        const componentKey = 'successors';
        const updatedInitialState = useTableCurrentState({ initialState, componentKey });

        return (
            <>
                {updatedInitialState && (
                    <MainTable
                        getInstanceCallback={(instance) => (ref.current = instance)}
                        columns={columns}
                        data={data}
                        initialState={updatedInitialState}
                        maxHeight={480}
                    />
                )}
                {ref?.current && (
                    <CustomTableColumnsModal
                        onHideModal={() => setModalColumnsOpen(false)}
                        showModal={modalColumnsOpen}
                        widgetId={undefined}
                        componentKey={componentKey}
                        tableInstance={ref.current}
                        initialState={initialState}
                        columns={columns}
                    />
                )}
            </>
        );
    },
);
